import React from 'react'
import { useParams } from "react-router-dom";
import HlasovaniDetail from './HlasovaniDetail';

const HlasovaniDetailWrapper = ({baseUrl, apiBaseUrl}) => {  
    let params = useParams();
    return <HlasovaniDetail id={params.hlasovaniId} baseUrl={ baseUrl } apiBaseUrl={ apiBaseUrl } />
};

export default HlasovaniDetailWrapper
